// Vexen logo wrapper — silver mark on dark surfaces, dark mark on light surfaces.
export const Logo = ({ size = 36, withText = true, lightWordmark = false }) => {
  const markSrc = lightWordmark ? "/vexen-mark-light.png" : "/vexen-mark-dark.png";
  return (
    <div className="flex items-center gap-3" data-testid="vexen-logo">
      <img
        src={markSrc}
        alt="Vexen"
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          flexShrink: 0,
        }}
        data-testid="vexen-logo-mark"
      />
      {withText && (
        <div className="leading-tight">
          <div
            className={`text-base font-bold tracking-tight font-display ${
              lightWordmark ? "text-white" : "text-slate-900"
            }`}
          >
            Vexen
          </div>
          <div
            className={`text-[10px] uppercase tracking-[0.18em] font-mono ${
              lightWordmark ? "text-slate-400" : "text-slate-500"
            }`}
          >
            Realty Intelligence
          </div>
        </div>
      )}
    </div>
  );
};
